import { render, staticRenderFns } from "./servehelp-table.vue?vue&type=template&id=79f24146&scoped=true&"
import script from "./servehelp-table.vue?vue&type=script&lang=js&"
export * from "./servehelp-table.vue?vue&type=script&lang=js&"
import style0 from "./servehelp-table.vue?vue&type=style&index=0&id=79f24146&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f24146",
  null
  
)

export default component.exports